import { AfterViewInit, Directive, ElementRef, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[tiLazyLoading]',
})
export class LazyLoadingDirective implements OnInit, AfterViewInit {
  @Output() public deferLoad: EventEmitter<any> = new EventEmitter();
  @Input() public forceIntersectionMode: boolean = false;
  private _intersectionObserver?: IntersectionObserver;
  private useIntersectionObserver: boolean = this.forceIntersectionMode;
  constructor(private _element: ElementRef) {
    if (this.checkLoadingSupport()) {
      this._element?.nativeElement?.setAttribute('loading', 'lazy');
    } else {
      // fallback to IntersectionObserver
      this.useIntersectionObserver = true;
    }
  }

  ngOnInit(): void {
    if (!this.checkLoadingSupport()) {
      this.useIntersectionObserver = true;
    }
  }

  checkLoadingSupport() {
    return 'loading' in HTMLImageElement.prototype && !this.forceIntersectionMode;
  }

  ngAfterViewInit() {
    if (this.useIntersectionObserver && IntersectionObserver) {
      this._intersectionObserver = new IntersectionObserver((entries) => {
        this.checkForIntersection(entries);
      }, {});
      this._intersectionObserver.observe(this._element.nativeElement as Element);
    }
  }

  private checkForIntersection(entries: IntersectionObserverEntry[]) {
    entries.forEach((entry: IntersectionObserverEntry) => {
      if (this.checkIntersecting(entry)) {
        this.deferLoad.emit();
        this._intersectionObserver.unobserve(this._element.nativeElement as Element);
        this._intersectionObserver.disconnect();
      }
    });
  }

  private checkIntersecting(entry: IntersectionObserverEntry) {
    return (entry as any).isIntersecting && entry.target === this._element.nativeElement;
  }
}
